import React, { Component } from "react";

import { Button } from "reactstrap";
import ReactTable from "react-table";
import "react-table/react-table.css"; 
import UpdateAgentForm from "./updateAgentForm";
//import AgentService from "../services";

const columns = [
  {
    Header:"Agent id",
    accessor: "agent_id",
    width: 90,
    // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header:"business name",
    accessor: "business_name", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header:"Mobile Number",
    accessor: "mobile_number", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: "agent status",
    accessor: "agent_status_name",
    width: 140,
    // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header:"proprieter name",
    accessor: "proprietor_name", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header:"city name",
    accessor: "city_name",
    width: 100,
    // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
 
  {
    Header: "آپریشن ", // Custom header components!
    accessor: "operation",
    width: 90,
    Cell: props => (
      <div className="d-flex justify-content-center">{props.value}</div>
    )
  }
];

export default class ListAgents extends Component {
  

  state = {
    updateUserModal: false,
    agentId: ""
  };

  componentDidMount() {
   // this.getUsers();
  }

  toggle = () => {
  
  
    this.setState(prevState => ({
      updateUserModal: !prevState.updateUserModal
    }));
  };

  showUpdateModal = id => {
    this.setState({agentId: id }, () => {
    this.toggle();
    });
  };
  
  getUsers = ()=>{
    this.props.getUsers();
  }
  render() {
    let { data } = this.props;
    //console.log("data",data);
    data.forEach(element => {
      element["operation"] = (
        <span>
          <Button
            onClick={() => {
              this.showUpdateModal(element["agent_id"]);
            }}
            color="primary"
            className="m-1"
            // disabled={}
          >
            <i className="fas fa-edit"></i>
          </Button>
          {/* <Button color="danger" className="m-1">
            <i class="fas fa-trash" aria-hidden="true"></i>
          </Button> */}
        </span>
      );
    });

    return (
      <div>
        <ReactTable
          data={data}
          columns={columns}
          showPaginationTop={true}
          showPaginationBottom={false}
        />
        
        {this.state.agentId !== "" ? (
          <UpdateAgentForm
            modal={this.state.updateUserModal}
            toggle={this.toggle}
            agentId={this.state.agentId}
            getUsers={this.getUsers}
          />
          
        ) : null}
      </div>
    );
  }
}
